<flx-flex-container>
	<div class="heading"><flx-heading type="page" size="medium">Recent Activity</flx-heading></div>
	<ul *ngIf="entries; else noEntries" class="entries">
		<li class="entry" *ngFor="let entry of entries" (click)="doSearch(entry)">
			<span class="claim-num">{{ entry.claim_num }}</span> <span class="applicant">{{ entry.applicant }}</span> <span class="time">{{ entry.access_date }}</span>
		</li>
	</ul>
	<ng-template #noEntries> <div class="no-entries">You have not accessed any claims recently</div> </ng-template>
</flx-flex-container>
